import React, { useMemo } from "react";
import { Container, Spinner } from "reactstrap";
import useMyProperties from "../../../hooks/useMyProperties";
import PageHero from "../../../components/Common/PageHero";
import InspectionsPanel from "../../../components/Common/InspectionsPanel";

/** Inspections across every property the manager can access. */
const InspectionsPage = () => {
  document.title = "Inspections | Support Portal";

  const { user, properties, loading } = useMyProperties();

  const scope = useMemo(
    () =>
      properties.map((p) => ({
        id: p.id,
        address: p.address,
        participantEmails: [
          user?.email,
          ...(p.sharedEmails || []),
          ...(p.tenantEmails || []),
        ].filter(Boolean),
      })),
    [properties, user?.email]
  );

  return (
    <div className="page-content">
      <Container fluid>
        <PageHero
          title="Inspections"
          subtitle="Schedule inspections, collect photos and videos, and talk them through with your tenants."
        />

        {loading ? (
          <div className="text-center py-5"><Spinner color="primary" /></div>
        ) : (
          <InspectionsPanel properties={scope} user={user} canManage />
        )}
      </Container>
    </div>
  );
};

export default InspectionsPage;
